export default {
  useFirebase: true,
  useFirebaseHosting: true,
};
